import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/onboardingSlice";

import onboardingApis from "src/api/onboarding";

import { common } from "src/types/index";
import { constants } from "src/constants/common";
import { getPatientDetailsSuccess } from "../slices/authSlice";

// send otp saga
const SendOtpSaga = function* SendOtpSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      onboardingApis.sendOtp,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.sendOtpSuccess(response));
    resolve(response);
  } catch (error) {
    yield put(
      actions.sendOtpError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// verify otp saga
const VerifyOtpSaga = function* VerifyOtpSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      onboardingApis.verifyOtp,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.verifyOtpSuccess(response?.data));
    yield put(getPatientDetailsSuccess(response?.data));
    resolve?.(response);
  } catch (error) {
    yield put(
      actions.verifyOtpError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    // reject?.(error);
  }
};

export default function* onboardingSaga() {
  yield all([
    takeEvery(actions.sendOtpRequest, SendOtpSaga),
    takeEvery(actions.verifyOtpRequest, VerifyOtpSaga),
  ]);
}
